import Vue from 'vue'
import Vuex from 'vuex'
import router from './router'
import axios from 'axios'

Vue.use(Vuex)
export default new Vuex.Store({
	state: {
		pincode: localStorage.getItem('pincode'),
		isLoggedIn: !!localStorage.getItem('isLoggedIn'),
		cartItems: localStorage.getItem('cartItems'),
		isSeller: localStorage.getItem('isSeller'),
	},
	mutations: {
		loginUser(state) {
			state.isLoggedIn = true
			localStorage.setItem('isLoggedIn', true)
		},

		logoutUser(state) {
			axios({
				method: "GET",
				url: "/user/logout",
				headers: {
					"x-auth-token": localStorage.getItem("token")
				}
			}).then(response => {
				if (response.data) {
					state.isSeller = false
					state.isLoggedIn = false
					localStorage.removeItem('isLoggedIn')
					localStorage.removeItem("token");
					localStorage.removeItem("isSeller")
					if (window.location.pathname != '/') {
						router.push('/')
					}
				}
			})
		},
		changePincode(state, item) {
			localStorage.setItem("pincode", item);
			state.pincode = item
		},
		changeCart(state, item) {
			localStorage.setItem("cartItems", item);
			state.cartItems = item
		},
		userType(state, item) {
			localStorage.setItem("isSeller", item);
			state.isSeller = item
		},
		sessionOut(state) {
			localStorage.removeItem('isLoggedIn')
			localStorage.removeItem("token");
			state.isLoggedIn = false
		}
	}

})